import { ElementPropertyName } from '@shared/models/element-property.model';
import { Baseline } from '@shared/models/project.model';
import { IProposal } from '@shared/models/proposals.model';
import { getBuildingEnvelopeElements } from '../energy/building-envelope.helpers';
import { NODE_ID } from './node-ids.helpers';

/**
 * Return node ids for envelope u-value (thermal transmittance) for all building envelope elements in scope.
 * Does not create nodes; used by computed variables and pipeline.
 * @param proposal When provided, only envelope elements active in this proposal are included (for per-proposal heat demand).
 */
export const getEnvelopeUValueNodeIds = (
  version: Baseline,
  elementIdsInScope: Set<string>,
  proposal?: IProposal,
): string[] => {
  const uValuePropName = ElementPropertyName.ThermalTransmittance;
  const ids: string[] = [];
  for (const envelopeElement of getBuildingEnvelopeElements(
    version,
    proposal,
  )) {
    if (!elementIdsInScope.has(envelopeElement.id)) continue;
    ids.push(NODE_ID.property(envelopeElement.id, uValuePropName));
  }
  return ids;
};
